'use client';

import { BigNum, QUOTE_PRECISION_EXP, User } from '@velocity-exchange/sdk';
import { ZERO_QUOTE_BIGNUM } from 'src/constants/math';

export const getTotalAllTimePnlForUserAccount = (
	user: User | undefined,
	excludeFunding = false
) => {
	const userAccount = user?.getUserAccount();
	if (!user || !userAccount) {
		return ZERO_QUOTE_BIGNUM;
	}

	const netBankValue = user.getNetSpotMarketValue();
	const unrealizedPnl = user.getUnrealizedPNL(
		!excludeFunding,
		undefined,
		undefined
	);

	const netUsdValue = netBankValue.add(unrealizedPnl);
	const totalDeposits = userAccount.totalDeposits;
	const totalWithdraws = userAccount.totalWithdraws;

	const totalPnl = netUsdValue.add(totalWithdraws).sub(totalDeposits);

	return BigNum.from(totalPnl, QUOTE_PRECISION_EXP);
};
